var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavbarNewsfeed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18157",
    "data-name": "Group 18157",
    transform: "translate(-2250 -1887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44040",
    "data-name": "Path 44040",
    d: "M5.625,9h-4.5A1.125,1.125,0,0,1,0,7.875V1.125A1.125,1.125,0,0,1,1.125,0h4.5A1.125,1.125,0,0,1,6.75,1.125v6.75A1.125,1.125,0,0,1,5.625,9",
    transform: "translate(2250 1887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44041",
    "data-name": "Path 44041",
    d: "M15.625,17h-4.5A1.125,1.125,0,0,1,10,15.875V9.125A1.125,1.125,0,0,1,11.125,8h4.5A1.125,1.125,0,0,1,16.75,9.125v6.75A1.125,1.125,0,0,1,15.625,17",
    transform: "translate(2251.25 1888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44042",
    "data-name": "Path 44042",
    d: "M5.625,16.625h-4.5A1.125,1.125,0,0,1,0,15.5V12.125A1.125,1.125,0,0,1,1.125,11h4.5A1.125,1.125,0,0,1,6.75,12.125V15.5a1.125,1.125,0,0,1-1.125,1.125",
    transform: "translate(2250 1888.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44043",
    "data-name": "Path 44043",
    d: "M15.625,5.625h-4.5A1.125,1.125,0,0,1,10,4.5V1.125A1.125,1.125,0,0,1,11.125,0h4.5A1.125,1.125,0,0,1,16.75,1.125V4.5a1.125,1.125,0,0,1-1.125,1.125",
    transform: "translate(2251.25 1887)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarNewsfeed);
export default __webpack_public_path__ + "static/media/navbar_newsfeed.c9277b55606de66ebc07d7f172063284.svg";
export { ForwardRef as ReactComponent };